import { useCallback, useState } from 'react'
import { Gift, Crown, Package, Coins } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const eur = (c) => `€${(Number(c || 0) / 100).toFixed(2)}`

export default function AdminPrijzenScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermPrijzen(); setD(r.data)
  }, [])
  const prijzen = d?.prijzen ?? []
  const openClaims = d?.openClaims ?? []
  const hoofd = d?.hoofdprijs
  const state = d?.state ?? { open:false }

  const soorten = d?.soortenBeschikbaar ?? 0
  const stuks   = d?.stuksBeschikbaar ?? 0

  return (
    <AdminScreenShell title="Prijzenkraam" subtitle="Voorraad · claims · hoofdprijs"
                      icon={Gift} refreshMs={20_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Winkel" waarde={state.open ? 'OPEN' : 'DICHT'}
               kleur={state.open ? '#61E294' : '#FFB57A'} groot />
        <Tegel label="Beschikbaar" waarde={stuks}
               sub={`${soorten} soorten · ${d?.uitverkocht ?? 0} uitverkocht`}
               kleur="#B4FF39" />
        <Tegel label="Claims 24u" waarde={d?.claimsVandaag ?? 0}
               sub={`${openClaims.length} open`} kleur="#61E294" />
        <Tegel label="Punten totaal"
               waarde={(d?.puntenTotaal ?? 0).toLocaleString('nl-BE')}
               sub="alle spelers samen" kleur="#B4FF39" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        {hoofd && (
          <div className="rounded-[6px] border-2 border-gold/50 bg-card p-4 col-span-2"
               style={{ background: '#FFD70011' }}>
            <div className="flex items-center gap-3">
              <Crown className="h-8 w-8 text-gold" />
              <div className="flex-1">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Hoofdprijs</div>
                <div className="text-2xl font-bold">{hoofd.name}</div>
                <div className="text-sm text-muted-foreground">
                  {hoofd.points_cost} punten ·
                  {hoofd.stock_remaining > 0 ? ` ${hoofd.stock_remaining} beschikbaar` : ' UITVERKOCHT'}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Package className="h-3 w-3 inline mr-1" /> Open claims
          </h2>
          {openClaims.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen open claims.</div>
          ) : openClaims.map(c => (
            <StatusRij key={c.id} naam={c.prijs ?? '—'}
                       sub={`${c.username ?? '—'}`}
                       status={c.status}
                       kleur={c.status === 'pending' ? '#FFB57A' : '#61E294'} />
          ))}
        </div>

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Coins className="h-3 w-3 inline mr-1" /> Voorraad-overzicht
          </h2>
          {prijzen.slice(0, 12).map(p => (
            <StatusRij key={p.id} naam={p.name}
                       sub={`${p.points_cost} pt`}
                       status={`${p.stock_remaining ?? 0}×`}
                       kleur={p.stock_remaining > 0 ? '#61E294' : '#FF5A5A'} />
          ))}
        </div>
      </div>
    </AdminScreenShell>
  )
}
